import Mun from "./Mun"

class Pair extends Mun {
}

export default Pair
